import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router";

import Button from "@components/buttons/Button";
import MessageTemplateCategoriesTable from "@components/MessageTemplateCategoriesTable";
import ExpertTablesPage from "@components/pageTypes/ExpertTablesPage";
import IconBase from "@components/text/IconBase";

const ExpertMessageTemplatesPage = () => {
  const location = useLocation();

  return (
    <ExpertTablesPage helmetKey="pageTitles.expert.messageTemplateCategory.list">
      <div className="banner">
        <Button fill="clear" routerLink={`/expert/message-templates${location.search}`}>
          <IconBase icon="chevronLeft" slot="start" />
          <FormattedMessage id="dictionary.back" />
        </Button>
      </div>

      <MessageTemplateCategoriesTable />
    </ExpertTablesPage>
  );
};

export default ExpertMessageTemplatesPage;
